module.exports = __webpack_public_path__ + "chevron/chevron-d014603602bbe8dd07f03d2fddc32ca7.svg";